import React from 'react'
import classNames from 'classnames'
import { DeliveryMethod } from '@dustin-web/microsite-config'
import Image from '@dustin-web/microsite-components/src/image'

const deliveryMethods = {
  posti: {
    src: 'https://media.dustin.eu/content/88623/posti.svg',
    width: 44,
    height: 20,
  },
  postnl: {
    src: 'https://media.dustin.eu/content/89833/postnl.svg',
    width: 34,
    height: 34,
  },
  bring: {
    src: 'https://media.dustin.eu/content/88632/bring.svg',
    width: 60,
    height: 30,
  },
  postnord: {
    src: 'https://media.dustin.eu/content/88633/postnord.svg',
    width: 90,
    height: 17,
  },
} as { [id in DeliveryMethod['id']]: { src: string; width: number; height: number } }

type DeliveryMethodDisplayProps = {
  item: DeliveryMethod
  className?: string
}

export const DeliveryMethodIcon = ({ item, className }: DeliveryMethodDisplayProps) => {
  const attrs = deliveryMethods[item.id]
  return attrs ? (
    <div className={classNames('u-mb-8 u-mb-sm-0 d-inline-flex', className)}>
      <Image {...attrs} alt={item.displayName} />
    </div>
  ) : null
}
